import { z } from 'zod';

// Filas completas de los catálogos de calidad tal como las devuelve qms-api
// (quality-catalogs). La pantalla de administración necesita más campos que los
// selectores (fragmento, frecuencia, padre); cada respuesta pasa por Zod.

const envelope = <T extends z.ZodType>(data: T) => z.object({ success: z.literal(true), data });

export const CODING_SCHEME_VALUES = ['proceso', 'sap', 'libre'] as const;
export type CodingScheme = (typeof CODING_SCHEME_VALUES)[number];

export const documentTypeSchema = z.object({
  id: z.string(),
  codeFragment: z.string(),
  name: z.string(),
  reviewFrequencyDays: z.number().int(),
  isActive: z.boolean(),
  // G3: codificación (04-GC-P08 §B.1) y plantilla controlada del tipo.
  codingScheme: z.enum(CODING_SCHEME_VALUES),
  templateEntryId: z.string().nullable(),
  template: z.object({ id: z.string(), code: z.string(), title: z.string().nullable() }).nullable(),
});
export type DocumentType = z.infer<typeof documentTypeSchema>;

export const processAreaSchema = z.object({
  id: z.string(),
  parentId: z.string().nullable(),
  codeFragment: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  // G3: tipo de proceso 01 a 04 (solo en el proceso principal).
  processType: z.number().int().min(1).max(4).nullable(),
});
export type ProcessArea = z.infer<typeof processAreaSchema>;

export const normClauseSchema = z.object({
  id: z.string(),
  normCode: z.string(),
  clause: z.string(),
  title: z.string(),
  isActive: z.boolean(),
});
export type NormClauseRow = z.infer<typeof normClauseSchema>;

export const customFieldDefinitionSchema = z.object({
  id: z.string(),
  fieldKey: z.string(),
  label: z.string(),
  dataType: z.string(),
  options: z.array(z.string()).nullable(),
  required: z.boolean(),
  /** Campo de fecha: avisar N días antes (reunión 2026-10-27); null = sin aviso. */
  reminderDays: z.number().int().nullable().default(null),
  /** Campo de fecha: avisar una vez cuando la fecha pasa. */
  notifyOverdue: z.boolean().default(false),
  schemaVersion: z.number().int(),
  isActive: z.boolean(),
});
export type CustomFieldDefinition = z.infer<typeof customFieldDefinitionSchema>;

export const documentTypesResponseSchema = envelope(z.array(documentTypeSchema));
export const processAreasResponseSchema = envelope(z.array(processAreaSchema));
export const normClausesResponseSchema = envelope(z.array(normClauseSchema));

export const documentTypeResponseSchema = envelope(documentTypeSchema);
export const processAreaResponseSchema = envelope(processAreaSchema);
export const normClauseResponseSchema = envelope(normClauseSchema);

/** Catálogo administrado en la pantalla. */
export type CatalogEntity = 'document_type' | 'process_area' | 'norm' | 'custom_field';
